import React from 'react'
import classNames from 'classnames'

export function ReviewLine({
  label,
  className,
  childrenClassName,
  children,
  border = true,
}) {
  return (
    <div
      className={classNames(
        'flexbox flexbox-align-center padding-vertical-medium',
        border && 'border-bottom-small border-shade-40',
        className
      )}
    >
      <div style={{ width: 200 }} className="shade-10">
        {label}
      </div>
      <div className={classNames('shade-05', childrenClassName)}>
        {children}
      </div>
    </div>
  )
}

export default ReviewLine
